
import { xorBy } from 'lodash';
import { takeLatest, takeEvery, put, select } from 'redux-saga/effects';
import { RootState } from '../..';
import { ADMISSION_FORM_TYPES } from '../../../shared/constants/crmConstants';

import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import { setAdmissionFormType } from '../../actions/newAdmissionAction';
import actionTypes from '../../types/detailTypes';
import { centeredNotification } from '../../../utils/utility';
import { showClaimDetailData } from '../../actions/claimDetailsAction';
import { SYNC_MESSAGE } from '../../../shared/constants/commonConstants';
import { encryptText } from '../../../utils/encryptDecrypt';
import { ApplicationDetailModel } from '../../models/applicationDetailModel';

export function* claimDetailsSaga(data: any): Generator {
  const payerNotConfig = yield select((state: RootState): any => state.selectedInPatientDetail.payerNotConfig);
  const {
    actionId, productCode, payerId, claimNo, isReimbursementClaim = false,
    successCallback = (): void => { },
    failedCallback = (): void => { },
  } = data.payload;
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const request = {
    claimNo,
    actionId,
    productCode,
    payerId,
    isReimbursementClaim,
    isNewTPADashboard: isNewTpaDeskEnabled,
  };

  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/ClaimDetail`;
  try {
    const response: any = yield sendRequest.post<any, any>
      (url, request);
    const { isSuccess, claimDetails } = response || {};
    if (isSuccess && claimDetails && payerNotConfig) {
      let admissionFormType = ADMISSION_FORM_TYPES.NORMAL;
      if (claimDetails.payerType === 'MultiPayer') {
        admissionFormType = ADMISSION_FORM_TYPES.MULTIPAYER;
      }
      if (claimDetails.payerType === 'CorporatePayor') {
        admissionFormType = ADMISSION_FORM_TYPES.CORPORATE;
      }

      yield put(setAdmissionFormType(admissionFormType));

    }
    if (isSuccess && claimDetails) {
      successCallback(claimDetails);
      localStorage?.setItem('claimDetailResponse', encryptText(JSON?.stringify(claimDetails)));
    } else {
      localStorage?.removeItem('claimDetailResponse');
      failedCallback();
    }
  } catch (e) {
    localStorage?.removeItem('claimDetailResponse');
    failedCallback(e);
  }
}

export function* verifyClaim({
  payload: { actionId, productCode, payerId, claimDetails: { allowStatus = [] }, successCallback: successResponse },
}: any): Generator {
  const successCallback = ({ allowStatus: incomingAllowStatus = [] }: any): void => {
    const diffActionName = xorBy(incomingAllowStatus, allowStatus, 'actionName');
    successResponse(!diffActionName.length);
  };

  const errorCallback = (): void => {
    successResponse(false);
  };
  yield claimDetailsSaga({ payload: { actionId, productCode, payerId, successCallback, errorCallback } });
}

export function* reSubmitClaimData({payload, onSuccess, onError}: any): any {
  try {
    const { isSuccess, errors } = yield SendRequest.instance.post(`${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/IntimatePayer`, payload);
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errors.join(', '));
    }
  } catch (errors: any) {
    onError(errors?.errorMessage);
  }
}

export function* statusSync({
    payload: {
      data: { payerClaimNumber, hospactionId, payerId, statusId, productCode, lastUpdatedDate },
      onSyncSuccess = (): void => {},
      onError = (): void => {},
    },
}: any): Generator {
  const request = {
    payerClaimNumber, hospactionId, payerId, statusId, productCode, lastUpdatedDate,
  };
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/FetchLatestClaimStatus`;
  try {
    const response: any = yield sendRequest.post<any, any>
      (url, request);
    const { isSuccess, errors } = response || {};
    if (isSuccess) {
      centeredNotification(SYNC_MESSAGE, 'success');
      yield put(showClaimDetailData(true));
      onSyncSuccess();
    } else {
      centeredNotification(errors);
      onError();
      yield put(showClaimDetailData(true));
    }
  } catch (e) {
    onError();
    centeredNotification('Sync Unsuccessful!');
  }
}

export function* watchClaimDetailsAction(): any {
  yield takeLatest(actionTypes.CLAIM_DETAILS, claimDetailsSaga);
  yield takeLatest(actionTypes.VERIFY_CLAIM, verifyClaim);
  yield takeEvery(actionTypes.RE_SUBMIT, reSubmitClaimData);
  yield takeLatest(actionTypes.MANUAL_STATUS_SYNC, statusSync);
}

export default watchClaimDetailsAction;
